module.exports = __webpack_public_path__ + "img/GIS_Threat.dd261f2e.svg";